import React from "react";
import { AxiosError } from "axios";
import { useContext } from "react";
import LogInForm from "./LogInForm";
import { navigationContext } from "../../routes/Root";
import { userContext } from "../Menu/MenuPicker";
import navValues from "../Menu/NavValues";
import { GetUserFromToken } from "../../components/Account/AuthenticationContext";

interface Props {
  title: string;
}

const Login = (props: Props): any => {
  const { navigate } = useContext(navigationContext) as any;
  const { userCallback } = useContext(userContext) as any;

  const handleLoginChange = (status: any) => {
    if (status === true) {
      navigate(navValues.loggedIn);
      getUser();
    } else {
      navigate(navValues.loggedOut);
    }
  };
  const getUser = () => {
    //process results from ajax call
    const successCallback = (result: any): void => {
      if (
        result &&
        result !== undefined &&
        result.Data &&
        result.Data !== undefined
      ) {
        //do logic
        if (result.Success === true) {
          userCallback(result.Data);
        }
      }
    };
    //handle errors
    const errorCallback = (error: AxiosError): void => {
      if (error) {
      }
    };
    GetUserFromToken({
      url: "Authentication/GetUser",
      data: {},
      successCallback,
      errorCallback,
    });
  };
  return (
    <div className="wrapper">
      <div className="section latest-offers">
        <div className="container">
          <h3 className="section-title">Log In</h3>
          <hr />
          <div className="col-md-6">
            <LogInForm onLoginStatusChange={handleLoginChange} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
